export default "/img/IE.7752f9d0a741b745567faf21ce37873b.png";